import domFn from '@/utils/domFn';
import http from '@/utils/http';
import PAGE_API from '@/apis/pageApi';
import HTTP_API from '@/apis/httpApi';
import { parseUrl } from '@/utils/url';
import { getPluginVersion } from '@/requests/plugin';
import { barToRemote, toRemoteCmd, routeAutoLogin } from '@/requests/bar';
import md5 from 'md5';
import { Message } from 'view-design';
window.$msg = Message;
// 插件调用类
class WhdsRemoteProtocal {
  constructor() {
    this.portocal = 'whdsRemoteProtol://';
    this.url = 'http://127.0.0.1:16880';
    // 是否已安装
    this.isInstalled = false;
    // 云端插件版本
    this.cloudVersion = null;
    // 本地插件版本
    this.localVersion = null;
    // 是否需要更新
    this.needUpdate = false;
    // 当前局域网的barid
    this.barId = null;
    // 正在远程的信息,{flag,name}
    this.remotingItems = [];
  }
  isRemoting(flag) {
    for (let index in this.remotingItems) {
      if (this.remotingItems[index].flag == flag) {
        return true;
      }
    }
    return false;
  }
  // 添加正在路由的
  addRemoting({ flag, name }) {
    for (let index in this.remotingItems) {
      if (this.remotingItems[index].flag == flag) {
        return true;
      }
    }
    this.remotingItems.push({
      flag,
      name,
    });
    window.$APP.$store.dispatch('plugin/actionSetRemotingArr', this.remotingItems);
  }
  // 删除正在路由的
  delRemoting(flag) {
    for (let index in this.remotingItems) {
      if (this.remotingItems[index].flag == flag) {
        window.$msg.error(this.remotingItems[index].name + '远程终止');
        this.remotingItems.splice(index, 1);
        return window.$APP.$store.dispatch('plugin/actionSetRemotingArr', this.remotingItems);
      }
    }
  }
  reportRemoteLog({ flag, barId, control }) {
    http.usualPost({
      url: HTTP_API.operationLog.addRemoteLog,
      data: {
        flag,
        barId,
        control,
        type: window.$APP.$route.query.isSelf == 2 ? 2 : 1,
      },
    });
  }
  // 启动插件
  launch() {
    // 插件运行状态，0:失败，1:成功
    this.runState = 0;
    if ('msLaunchUri' in navigator) {
      // 如果是windows8，IE10+，可以支持这种方式调起客户端。
      navigator.msLaunchUri(this.portocal, this.launchSuccess(), this.launchFail());
      return;
    }
    this.iframeDom = document.createElement('iframe');
    this.iframeDom.style.opacity = 0;
    this.iframeDom.style.width = 0;
    this.iframeDom.style.height = 0;
    document.body.appendChild(this.iframeDom);
    this.inputDom = document.createElement('input');
    this.inputDom.style.opacity = 0;
    document.body.appendChild(this.inputDom);

    this.inputDom.focus();
    this.inputDom.onblur = () => {
      if (document.activeElement && document.activeElement !== this.inputDom) {
        this.inputDom.focus(); // 防止用户因为随机操作，而误认为是调起了客户端。
      } else {
        this.runState = 1;
      }
    };

    try {
      this.iframeDom.src = this.portocal;
      setTimeout(() => {
        if (!this.runState) {
          this.launchFail();
        } else {
          this.launchSuccess();
        }
      }, 1200);
      this.iframeDom.onerror = () => {
        this.launchFail();
      };
      // this.launchSuccess()
    } catch (error) {
      // 说明没有注册协议
      this.launchFail();
    }
  }
  needInstall() {
    window.$Message.show({
      title: '提示',
      type: 'error',
      msg: '请先下载远控插件',
      cancleBtn: true,
      confirmTxt: '立即下载',
      confirmFn: () => {
        window.open(PAGE_API.other.downloadPlugin);
        window.$Message.hide();
      },
    });
  }
  // 初始化插件状态
  init() {
    // 检查版本
    this.checkVersion();
    // 获取barID
    this.getBarId();
  }
  async getBarId() {
    let res = await http.get({
      url: this.url,
      data: {
        cmdid: 10007,
        barid: '',
      },
    });
    if (res.err == 0) {
      this.barId = res.msg;
    }
  }
  // 插件启动成功
  launchSuccess() {
    domFn.remove(this.iframeDom);
    domFn.remove(this.inputDom);
  }
  // 插件启动失败
  launchFail() {
    domFn.remove(this.iframeDom);
    domFn.remove(this.inputDom);
  }
  // 检测本地插件版本
  async checkVersion() {
    let res = await http.get({
      url: this.url,
      data: {
        cmdid: 10000,
        version: '',
      },
    });
    if (res.err == 0 && res.msg) {
      this.localVersion = res.msg.split('=')[1];
      this.isInstalled = true;
      this.cloudVersion = await getPluginVersion();
      if (this.cloudVersion == this.localVersion) {
        this.needUpdate = false;
        window.$APP.$store.dispatch('plugin/actionSetNeedUpdate', false);
      } else {
        this.needUpdate = true;
        window.$APP.$store.dispatch('plugin/actionSetNeedUpdate', true);
      }
    } else {
      this.isInstalled = false;
    }
  }
  async isNeedInstall() {
    await this.checkVersion();
    if (!this.isInstalled) {
      this.needInstall();
      return false;
    }
    return true;
  }
  // 远程直连探测
  async isDirectRemote({ ip, port }) {
    let res = await http.get({
      url: this.url,
      data: {
        cmdid: 10001,
        ip,
        port,
      },
    });
    if (res.err == 0) {
      return true;
    } else {
      return false;
    }
  }
  // 远程cmd命令协议
  async remoteCmd({ barId, flag, local, name, isOnline, computerName }, isServer) {
    if (!isOnline) {
      console.log(window.$msg);
      return window.$msg.error('离线状态下不能操作');
    }
    let l = '';
    if (window.$msg && window.$msg.loading) {
      l = window.$msg.loading('请稍候...');
    }
    let res = await this.isNeedInstall();
    if (!res) {
      return false;
    }
    let remoteData = await toRemoteCmd({
      barId,
      type: isServer ? 0 : 1,
      flag,
    });
    if (remoteData.code != 200) {
      return l.destroy()();
    } else {
      remoteData = remoteData.data;
      res = await http.get({
        url: this.url,
        data: {
          cmdid: 10005,
          ip: remoteData.ip,
          port: remoteData.port,
          psw: remoteData.psw,
          flag: remoteData.flag,
          local,
          name: computerName || name,
        },
      });
      setTimeout(() => {
        l.destroy()();
      }, 1000);
      if (res.err == 0) {
        this.addRemoting({
          flag,
          name: computerName || name,
        });
        /* eslint-disable */
        console.log('远程cmd执行成功');
        // this.reportRemoteLog({
        //     flag,
        //     barId
        // })
      } else {
        window.$msg.error('远程cmd失败');
      }
    }
  }
  // 中转远程
  async transferRemote(
    { barId, barName, localIp, flag, name, computerName, isOnline },
    isServer,
    isViewonly,
    type
  ) {
    if (!isOnline) {
      return window.$msg.error('离线状态下不能操作');
    }
    let viplevel, comfirmImg, comfirmText, flagVal, errorMsg;
    if (
      window.$APP.$store.state.user.userInfo.judgeVip == 0 ||
      window.$APP.$store.state.user.userInfo.vipStatus == 0
    ) {
      viplevel = 0;
      comfirmImg = 1;
      comfirmText = '开通VIP';
      errorMsg =
        '抱歉！免费用户并发远程控制主机数量为3台。开通VIP会员可同时控制6台，开通SVIP会员可同时控制9台！';
    } else if (
      window.$APP.$store.state.user.userInfo.judgeVip == 2 &&
      window.$APP.$store.state.user.userInfo.vipStatus > 0
    ) {
      viplevel = 1;
      comfirmImg = 2;
      comfirmText = '升级SVIP';
      errorMsg = '抱歉！VIP用户并发远程控制主机数量为6台。升级SVIP会员可同时控制9台！';
    } else if (
      (window.$APP.$store.state.user.userInfo.judgeVip == 1 &&
        window.$APP.$store.state.user.userInfo.vipStatus > 0) ||
      (window.$APP.$store.state.user.userInfo.judgeVip == 3 &&
        window.$APP.$store.state.user.userInfo.vipStatus > 0)
    ) {
      viplevel = 2;
      comfirmImg = 0;
      comfirmText = '确定';
      errorMsg = '抱歉！SVIP会员可同时控制9台！';
    }
    flagVal = flag + md5(window.$APP.$store.state.user.userInfo.passportName).slice(0, 8);
    let l = '';
    if (window.$msg && window.$msg.loading) {
      l = window.$msg.loading('请稍候...');
    }
    let res = await this.isNeedInstall();
    if (!res) {
      l.destroy()();
      return false;
    }
    let remoteData = await barToRemote({
      barId,
      flag,
      isServer, //是否位服务器，0|1
      control: 1,
    });
    if (remoteData.code != 200) {
      l.destroy()();
      window.$Message.show({
        title: '被控端连接数量受限',
        type: 'error',
        msg: remoteData.msg,
        cancleBtn: true,
        confirmImg: comfirmImg,
        confirmTxt: comfirmText,
        // cancelTxt: "确定",
        confirmFn: () => {
          window.$APP.$router.push({
            path: window.$APP.$PAGE_API.home.children.VIPInfo.path,
          });
          window.$Message.hide();
        },
      });
    }
    remoteData = remoteData.data;
    res = await http.get({
      url: this.url,
      data: {
        cmdid: 10002,
        ip: remoteData.ip,
        psw: remoteData.psw,
        viewonly: isViewonly ? 'yes' : 'no',
        key: remoteData.key,
        flag: flagVal,
        local: localIp,
        name: barName ? barName : window.$APP.$store.state.barDetails.barName,
        machine: computerName ? computerName : name,
        viplevel: viplevel,
        mode: type,
      },
    });
    setTimeout(() => {
      l.destroy()();
    }, 3000);
    if (res.err == 0) {
      this.addRemoting({
        flag,
        name: computerName ? computerName : name,
      });
      window.$APP.$forceUpdate();
      this.reportRemoteLog({
        flag,
        barId,
        control: isViewonly ? 0 : 1,
      });
    } else if (res.err == -4) {
      l.destroy()();
      if (comfirmImg) {
        window.$Message.show({
          title: '并发控制数量受限',
          type: 'error',
          msg: errorMsg,
          cancleBtn: true,
          confirmImg: comfirmImg,
          confirmTxt: comfirmText,
          confirmFn: () => {
            window.$APP.$router.push({
              path: window.$APP.$PAGE_API.home.children.VIPInfo.path,
            });
            window.$Message.hide();
          },
        });
      } else {
        window.$Message.show({
          title: '并发控制数量受限',
          type: 'error',
          msg: errorMsg,
          cancleBtn: true,
          confirmImg: comfirmImg,
          confirmTxt: comfirmText,
          confirmFn: () => {
            window.$Message.hide();
          },
        });
      }
    } else {
      l.destroy()();
      window.$msg.error('远程控制失败');
    }
  }
  // 杀VNC
  async killRemote(flag) {
    let res = await http.get({
      url: this.url,
      data: {
        cmdid: 10006,
        data: {
          flag: flag ? flag : 'all',
        },
      },
    });
    if (res.err == 0) {
      console.log('关闭成功');
    } else {
      console.log('关闭失败');
    }
  }
  // TCP链路保活
  async runHeart() {
    try {
      let res = await http.get({
        url: this.url,
        data: {
          cmdid: 10003,
          keepalive: 1,
        },
      });
      this.handleHeart(res);
      if (res.Tag == 'ERROR') {
        this.isInstalled = false;
        window.$APP.$store.dispatch('plugin/actionSetIsInstalled', false);
      } else {
        this.isInstalled = true;
        window.$APP.$store.dispatch('plugin/actionSetIsInstalled', true);
      }
    } catch (err) {
      /* eslint-disable */
      console.log(err);
    }
    if (process.env.NODE_ENV == 'development') {
      return;
    }
    setTimeout(() => {
      this.runHeart();
    }, 100);
  }
  // 处理心跳返回的消息
  handleHeart(data) {
    switch (parseInt(data.ID)) {
      case 10004:
        for (let index in this.remotingItems) {
          if (this.remotingItems[index].flag == data.msg) {
            this.delRemoting(data.msg);
          }
        }
        break;
      default:
        break;
    }
  }
  async routerAutoLogin({ routerId }) {
    let l = '';
    if (window.$msg && window.$msg.loading) {
      l = window.$msg.loading('请稍候...');
    }
    setTimeout(() => {
      l.destroy()();
    }, 6000);
    let res = await this.isNeedInstall();
    if (!res) {
      l.destroy()();
      return window.$msg.error(res.msg);
    }
    let cmdid = 20001;
    res = await routeAutoLogin({
      routerId,
    });
    if (res.code == 200) {
      res = res.data;
    } else {
      return l.destroy()();
    }
    if (res.type == 2) {
      res = await http.get({
        url: this.url,
        data: {
          cmdid,
          cookies: null,
          url: null,
          domain: null,
          type: 2,
          js: encodeURIComponent(res.js),
        },
      });
    } else if (res.type == 1) {
      let domain = parseUrl(res.url).host;
      res = await http.get({
        url: this.url,
        data: {
          cmdid,
          // cookies: res.cookies.replace('; path=/',';path=/;expires=Sun,18-Jan-2038 00:00:00 GMT').replace(/^\s+|\s+$/g,''),
          cookies: res.cookies,
          url: res.url,
          domain,
          type: 1,
          js: null,
        },
      });
    } else {
      return l.destroy()();
    }
    l.destroy()();
    if (res.err == 0) {
      console.log('执行成功');
    } else {
      window.$msg.error(res.msg);
    }
  }
}
export default new WhdsRemoteProtocal();
